import { MetaData } from "@qid/core";

export class FeatureGroup extends MetaData {
  keyName: string;
  name: string;
  description: string;
  _id: any;


  constructor() {
    super();
  }

}



